
export function uploading (bool, msg) {
  var html = '<div style="width:200px;height:55px;position:fixed;top:30%;left:45%;z-index:9999999;' +
    'background-color:rgba(0,0,0,0.7);text-align:center;line-height:55px;border-radius:3px;color:#FFFFFF;" id="imgUpload">' + msg + '</div>'
  if (bool) {
    $("body").append(html);
  }
  else {
    if ($("#imgUpload")) {
      $("#imgUpload").remove()
    }
  }
}
export function download (sUrl, filename) {
  if (sUrl.indexOf('https') === 0) {
    sUrl = sUrl.substring(6)
  } else if (sUrl.indexOf('http') === 0) {
    sUrl = sUrl.substring(5)
  }
  if (typeof window.chrome !== 'undefined') {
    // Chrome version
    var link = document.createElement('a');
    link.href = sUrl
    link.download = filename;
    link.click();
  }
  else if (typeof window.navigator.msSaveBlob !== 'undefined') {
    // IE version
    var blob = new Blob([sUrl], { type: 'application/force-download' });
    window.navigator.msSaveBlob(blob, filename);
  }
  else {
    // Firefox version
    var file = new File([sUrl], filename, { type: 'application/force-download' });
    window.open(URL.createObjectURL(file));
  }
}
